export default __webpack_public_path__ + "065bb26f89f0e3119551b04a826adacc.webp";